import { render, staticRenderFns } from "./SettingsPresets.vue?vue&type=template&id=2044c001&scoped=true"
import script from "./SettingsPresets.vue?vue&type=script&setup=true&lang=ts"
export * from "./SettingsPresets.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SettingsPresets.vue?vue&type=style&index=0&id=2044c001&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2044c001",
  null
  
)

export default component.exports